import React, { Component } from 'react';
import { logger } from '@fiverr-private/perseus';

class ErrorBoundary extends Component {

    static getDerivedStateFromError() {
        return {
            hasError: true
        };
    }

    constructor(props) {
        super(props);

        this.state = {
            hasError: false
        };
    }

    componentDidCatch(error) {
        logger.error(error);
    }

    render() {
        const { hasError } = this.state;

        if (hasError) {
            return null;
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
